import { render, staticRenderFns } from "./PageContentOrphaned.vue?vue&type=template&id=53d75291&scoped=true"
import script from "./PageContentOrphaned.vue?vue&type=script&lang=js"
export * from "./PageContentOrphaned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d75291",
  null
  
)

export default component.exports